import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/global-network/page.tsx");
